import {STATUS} from '@/const/status/index';
import {FormType} from './editingTypes';

export const InitialFormData: FormType = {
    id: undefined,
    customID: null,
    // purpose: '참여',
    category: {
        major: '',
        sub: '',
    },
    name: '',
    status: STATUS.ACTIVE,
    app: null,
    budget: {
        limited: false,
        type: 'total',
        value: 0,
    },
    // country: '',
    date: [],
    partner: {
        company: '',
        advertiser: '',
    },
    totalFrequency: {
        isUsed: false,
        whichUsed: 'impression',
        impression: 0,
        click: 0,
    },
    dailyFrequency: {
        isUsed: false,
        whichUsed: 'impression',
        impression: 0,
        click: 0,
    },
    impressionInterval: {
        isUsed: false,
        value: 0,
    },
    dailyEquality: false,
    impWeight: 0,
    // tracking: '',
}